import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import type { TenantLicenseRequest } from '../../tenants/api/tenants';

dayjs.extend(utc);

export function toTenantLicenseRequest(values: {
  useDefaultTrial: boolean;
  licenseEndsAt?: Dayjs;
}): TenantLicenseRequest {
  return {
    useDefaultTrial: values.useDefaultTrial,
    licenseEndsAtUtc: values.useDefaultTrial
      ? undefined
      : values.licenseEndsAt?.utc().startOf('day').toISOString(),
  };
}
